//import RequestOrderPopup from "@/pages/comp/book_order/shop/order/popup/request_order";
import RequestOrderPopupArea from "@/pages/comp/book_order/shop/order/acommon/request_order_popup";

function RequestOrderPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    mcomp_seq: 0,
    stu_seq_arr: 0,
    ...props
  };

  return (
    <div>
      <RequestOrderPopupArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        mcomp_seq={myProps.mcomp_seq}
        stu_seq_arr={myProps.stu_seq_arr}
      ></RequestOrderPopupArea>
    </div>
  );
};
export default RequestOrderPopup;